var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 112,
    viewBox: "0 0 343 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4924e-06 22L0 69H6.68532e-05L6.83874e-05 53.7168C0.00325389 60.9049 4.74653 66.9847 11.2737 69H15C25.4934 69 34 77.5066 34 88V101.29C36.2647 107.375 42.1261 111.71 49 111.71H34L34 112L321 112C333.15 112 343 102.15 343 90V43L343 58.2832C342.997 51.0951 338.253 45.0153 331.726 43H328C317.507 43 309 34.4934 309 24V10.7097C306.735 4.62466 300.874 0.289943 294 0.289943L309 0.289945V0L22 2.84474e-05C9.84974 2.95907e-05 3.4924e-06 9.84976 3.4924e-06 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyCart);
export default __webpack_public_path__ + "static/media/readyCart.36f2a70af3bf26cd62450152996b163c.svg";
export { ForwardRef as ReactComponent };